import { internal, template } from '../../../vendor/elix.js';

import DisableableMixin from '../../mixins/disableable-mixin.js';
import FocusableMixin from '../../mixins/focusable-mixin.js';
import LabelMixin from '../../mixins/labels/label-mixin.js';
import RippleMixin from '../../mixins/ripple-mixin.js';
import HelperTextMixin from '../../mixins/helper-text-mixin.js';

function ButtonMixin(Base) {

  return class Button extends
    LabelMixin(
    FocusableMixin(
    DisableableMixin(
    RippleMixin(
      Base
    )))) {

   
    connectedCallback() {
      super.connectedCallback();
      this.addEventListener('click', this._onClick.bind(this))
      
      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', 0);
      }
    }

    get type() {
      return this[internal.state].type;
    }

    set type(type) {
      this[internal.setState]({ type });
    }

    get form() {
      if(this[internal.state].form) {
        return this.ownerDocument
          .querySelector(`form[name="${this[internal.state].form}"]`);
      } else {
        return this.closest('form');
      }
    }

    set form(form) {
      this[internal.setState]({ form });
    }

    [internal.render](changed) {
      super[internal.render](changed);
      if (changed.type) {
        this.renderType();
      }
    }

    renderType() {
      const inner = this[internal.ids].inner;
      if (inner) {
        inner.type = this.type;
      }
    }

    get [internal.template]() {

      return template.concat(

        super[internal.template],

        template.html`
          <style>

            :host {
              display: inline-block;
              -moz-appearance: none !important;
              -webkit-appearance: none !important;
            }
            
            #inner {
              background-image: none;
              border-radius: var(--tp-button-mixin-border-radius);
              border: none;
              color: var(--tp-button-mixin-font-color);
              cursor: pointer;
              font-family: var(--tp-button-mixin-font-family);
              font-size: var(--tp-button-mixin-font-size);
              height: auto;
              outline: none;
              width: 100%;
              background-clip: padding-box;  
              -moz-background-clip: padding;  
              -webkit-background-clip: padding;
              overflow: hidden;
            }

            #inner[disabled], #inner:disabled {
              cursor: default;
              opacity: 0.6;
            } 
          </style>
        `
      );
    }

    _onClick(e) {
      setTimeout(() => {
        if (this.form && !e.defaultPrevented) {
          switch(this.type) {
            case 'submit':
              this._trySubmitForm();
              break;
            case 'reset':
              this._tryResetForm();
              break;
          }
        }
      });
    }

    _trySubmitForm() {
      const submitEvent = new CustomEvent('submit', { cancelable: true });
      this.form.dispatchEvent(submitEvent);
      if(!submitEvent.defaultPrevented) {
        this.form.submit();
      }
    }

    _tryResetForm() {
      const resetEvent = new CustomEvent('reset', { cancelable: true });
      this.form.dispatchEvent(resetEvent);
      if(!resetEvent.defaultPrevented) {
        this.form.reset();
      }
    }

  }

}

export default ButtonMixin;
